import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '../KeyComponents';

function TabMenuItem(props) {
  const {
    className,
    label,
    type,
    leftIcon,
    rightIcon,
    active,
    onClick,
  } = props;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames('pgn__tabmenu-item', `pgn__tabmenu-item-${type}`, className)}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      data-testid="tabmenu-item"
    >
      <div className={classNames('pgn__tabmenu-item-container', { 'tabmenu-item-active': active })}>
        {leftIcon && <Icon className="pgn__tabmenu-tabs-right-icon" icon={leftIcon} data-testid="left-icon" />}
        <span className="pgn__tabmenu-tabs-label">
          {label}
        </span>
        {rightIcon && <Icon className="pgn__tabmenu-tabs-left-icon" icon={rightIcon} data-testid="right-icon" />}
      </div>
    </div>
  );
}

function TabMenu(props) {
  const {
    className,
    type,
    children,
    border
  } = props;

  const tabMenuItems = React.Children.map(children, (child) => React.cloneElement(child, {
    type,
  }));

  return (
    <div className={classNames('pgn__tabmenu', `pgn__tabmenu-${type}`, { 'pgn__tabmenu-border': (border && type === 'vertical') }, className)} data-testid="tabmenu">
      {type === 'vertical' && (
        <span className="pgn__tabmenu-title-text">
          Select Menu
        </span>
      )}
      {tabMenuItems}
    </div>
  );
}

TabMenu.Item = TabMenuItem;

TabMenuItem.propTypes = {
  type: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  className: PropTypes.string
};

TabMenuItem.defaultProps = {
  type: 'horizontal',
  active: false,
  onClick: () => { },
  label: '',
  leftIcon: '',
  rightIcon: '',
  className: ''
};

TabMenu.propTypes = {
  type: PropTypes.string,
  border: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};

TabMenu.defaultProps = {
  type: 'horizontal',
  border: false,
  children: null,
  className: ''
};

export default TabMenu;
